import React from "react";
import Loader from "../../Helper/Loader";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { WarningAmber } from "@mui/icons-material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

export default function DeleteConfirmationPopup({
  setOpenDeleteQuestionBankConfirmationPopup,
  deleteQuestionBankData,
  handleDeleteQuestionBank,
  isProcessLoading,
}) {
  return (
    <Dialog
      open={true}
      onClose={() => setOpenDeleteQuestionBankConfirmationPopup(false)}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: "8px",
        },
      }}
    >
      {isProcessLoading ? (
        <DialogContent sx={{ textAlign: "center", py: 4 }}>
          <Loader />
        </DialogContent>
      ) : (
        <>
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              fontWeight: 700,
              color: "#111827",
              pb: 1,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#FEE2E2",
                color: "#DC2626",
                borderRadius: "50%",
                padding: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <WarningAmber fontSize="small" />
            </Box>
            Delete Question Bank?
          </DialogTitle>

          <DialogContent>
            <Typography
              variant="body1"
              sx={{ color: "#4B5563", fontSize: "14px" }}
            >
              Are you sure you want to delete{" "}
              <b>
                {deleteQuestionBankData?.questionBankName ||
                  "this question bank"}
              </b>
              ? This action cannot be undone.
            </Typography>
          </DialogContent>

          <DialogActions sx={{ padding: "16px 24px 24px 24px", gap: 1 }}>
            <Button
              onClick={() => setOpenDeleteQuestionBankConfirmationPopup(false)}
              variant="outlined"
              sx={{
                color: "#4B5563",
                borderColor: "#D1D5DB",
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "#F9FAFB",
                  borderColor: "#9CA3AF",
                },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() =>
                handleDeleteQuestionBank(deleteQuestionBankData.questionBankId)
              }
              variant="contained"
              startIcon={<DeleteOutlineIcon fontSize="small" />}
              sx={{
                backgroundColor: "#DC2626",
                color: "#fff",
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                boxShadow: "0 4px 6px rgba(220, 38, 38, 0.2)",
                "&:hover": {
                  backgroundColor: "#B91C1C",
                  boxShadow: "0 6px 8px rgba(220, 38, 38, 0.3)",
                },
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}
